import { ConsignmentState } from '@glow/entity-types'
import { Map } from 'immutable'
import {
  WEB_SOCKET_ADD_CONTEXTS,
  WEB_SOCKET_REMOVE_CONTEXTS,
  WEB_SOCKET_SET_CONTEXT,
  WEB_SOCKET_SET_CONTEXT_CONSIGNMENT_STATES,
  WEB_SOCKET_SET_CONTEXT_DATES,
  WEB_SOCKET_SET_CONTEXT_DEPARTMENTS
} from '../actions/actionTypes'
import { CustomerIdType } from '../domain/customer'
import { MainAccessType } from '../domain/mainAccessType'
import { DepartmentIdType, RouteLabelIdType, SlotIdType } from '../types/coreEntitiesTypes'
import { EventType } from '../utils/consignmentEvent'
import { WebSocketContext, WebSocketContextImmutable, WebSocketContextTypes, WebSocketFilterTypes } from '../ws/wsUtils'

export interface SetContextAction {
  type: typeof WEB_SOCKET_SET_CONTEXT
  departmentIds: DepartmentIdType[]
  dates: string[]
  customerIds?: CustomerIdType[]
  contexts: WebSocketContextTypes[]
  types?: MainAccessType[]
  filters?: WebSocketFilterTypes[]
  consignmentStates?: ConsignmentState[]
  consignmentEventTypes?: EventType[]
  slotIdsBypassingConsignmentStateFilter?: SlotIdType[]
  labelIdsByCategory?: Record<string, RouteLabelIdType[]>
}

interface SetContextDepartments {
  type: typeof WEB_SOCKET_SET_CONTEXT_DEPARTMENTS
  departmentIds: DepartmentIdType[]
}

interface SetContextDates {
  type: typeof WEB_SOCKET_SET_CONTEXT_DATES
  dates: string[]
}

interface SetContextConsignmentStates {
  type: typeof WEB_SOCKET_SET_CONTEXT_CONSIGNMENT_STATES
  states: ConsignmentState[]
}

interface RemoveContexts {
  type: typeof WEB_SOCKET_REMOVE_CONTEXTS
  contexts: WebSocketContextTypes[]
}

interface AddContexts {
  type: typeof WEB_SOCKET_ADD_CONTEXTS
  contexts: WebSocketContextTypes[]
}

type ContextAction =
  | SetContextAction
  | AddContexts
  | SetContextDepartments
  | SetContextDates
  | RemoveContexts
  | SetContextConsignmentStates

const initialState: WebSocketContextImmutable = Map({
  contexts: ['NONE'] as WebSocketContextTypes[],
  customerIds: [],
  dates: [],
  departmentIds: [],
  types: [],
  filters: [],
  consignmentStates: [],
  consignmentEventTypes: [],
  slotIdsBypassingConsignmentStateFilter: [],
  labelIdsByCategory: {}
} as WebSocketContext)

export default (state = initialState, action: ContextAction) => {
  switch (action.type) {
    case WEB_SOCKET_SET_CONTEXT:
      return state.withMutations((it: WebSocketContextImmutable) =>
        it
          .set('departmentIds', action.departmentIds || state.get('departmentIds'))
          .set('dates', action.dates || state.get('dates'))
          .set('customerIds', action.customerIds || state.get('customerIds'))
          .set('contexts', action.contexts || state.get('contexts'))
          .set('types', action.types || state.get('types'))
          .set('filters', action.filters || state.get('filters'))
          .set('consignmentStates', action.consignmentStates || state.get('consignmentStates'))
          .set('consignmentEventTypes', action.consignmentEventTypes || state.get('consignmentEventTypes'))
          .set(
            'slotIdsBypassingConsignmentStateFilter',
            action.slotIdsBypassingConsignmentStateFilter || state.get('slotIdsBypassingConsignmentStateFilter')
          )
          .set('labelIdsByCategory', action.labelIdsByCategory || state.get('labelIdsByCategory'))
      )
    case WEB_SOCKET_ADD_CONTEXTS: {
      const newContexts = new Set(state.get('contexts').concat(action.contexts))
      return state.set('contexts', Array.from(newContexts))
    }
    case WEB_SOCKET_REMOVE_CONTEXTS: {
      const l = new Set(state.get('contexts'))
      action.contexts.forEach((it) => l.delete(it))
      return state.set('contexts', Array.from(l))
    }
    case WEB_SOCKET_SET_CONTEXT_DATES:
      return state.set('dates', action.dates)
    case WEB_SOCKET_SET_CONTEXT_DEPARTMENTS:
      return state.set('departmentIds', action.departmentIds)
    case WEB_SOCKET_SET_CONTEXT_CONSIGNMENT_STATES:
      return state.set('consignmentStates', action.states)
    default:
      return state
  }
}
